export function RoomStyles() {
  return (
    <style>{`
      .room-root { min-height: 100vh; background: var(--bg); }
      .room-root > div { max-width: 1100px; margin: 0 auto; padding: 32px 24px 64px; }

      .connecting, .big-error, .id-sel, .lobby, .game { width: 100%; }
      .connecting { display: flex; flex-direction: column; align-items: center; gap: 24px; padding-top: 120px; }
      .spinner { width: 36px; height: 36px; border-radius: 50%; border: 3px solid var(--line); border-top-color: var(--accent); animation: spin 0.9s linear infinite; }
      @keyframes spin { to { transform: rotate(360deg); } }

      .big-error { display: flex; flex-direction: column; gap: 16px; align-items: flex-start; max-width: 480px; padding-top: 80px; }
      .big-error h1 { font-family: 'Oswald'; font-weight: 600; font-size: 56px; line-height: 1; margin: 4px 0; letter-spacing: -.01em; }
      .big-error p { color: var(--ink-dim); font-size: 15px; line-height: 1.5; margin: 0; }

      .banner { background: color-mix(in srgb, var(--danger) 18%, transparent); border: 1px solid var(--danger); color: var(--ink); padding: 10px 14px; border-radius: var(--radius-btn); font-family: 'JetBrains Mono'; font-size: 12px; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 16px; }

      /* identity selection */
      .id-sel { max-width: 560px; margin: 0 auto; padding-top: 40px; }
      .id-sel h1 { font-family: 'Oswald'; font-weight: 600; font-size: 56px; line-height: 1; margin: 8px 0 4px; letter-spacing: -.01em; }
      .muted { color: var(--ink-dim); font-size: 15px; margin: 0 0 28px; }
      .name-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 24px; }
      .name-btn { position: relative; display: flex; flex-direction: column; gap: 4px; align-items: flex-start; text-align: left; background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 18px 20px; cursor: pointer; color: var(--ink); transition: background .2s, border-color .2s, transform .15s var(--ease); }
      .name-btn:hover { background: var(--bg3); border-color: var(--line-strong); }
      .name-btn:active { transform: translateY(1px); }
      .name-btn[data-status="connected"] { border-color: var(--accent); }
      .name-btn .name { font-family: 'Oswald'; font-weight: 600; font-size: 28px; letter-spacing: -.005em; }
      .name-btn .status { font-family: 'JetBrains Mono'; font-size: 10px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--ink-faint); }
      .name-btn .star { position: absolute; top: 12px; right: 14px; color: var(--accent); }
      .err { margin-top: 16px; color: var(--danger); font-size: 13px; }

      /* lobby */
      .lobby { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; align-items: start; padding-top: 32px; }
      .lobby-left { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }
      .lobby-left h1 { font-family: 'Oswald'; font-weight: 600; font-size: 48px; line-height: 1; margin: 8px 0 0; letter-spacing: -.01em; }
      .join-url { font-size: 12px; color: var(--ink-dim); word-break: break-all; max-width: 280px; }
      .lobby-right .panel { background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 24px; }
      .panel-head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 16px; }
      .pill.on { border-color: var(--accent); color: var(--accent); }
      .lobby-list { display: flex; flex-direction: column; margin-bottom: 20px; }
      .lobby-player { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid var(--line); }
      .lobby-player:last-child { border-bottom: 0; }
      .lobby-player[data-status="connected"] .lp-status { color: var(--accent); }
      .lobby-player[data-status="disconnected"] .lp-name { color: var(--ink-dim); }
      .lp-name { font-family: 'Oswald'; font-weight: 500; font-size: 22px; }
      .lp-status { font-family: 'JetBrains Mono'; font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--ink-faint); }
      .hint { font-size: 12px; color: var(--ink-dim); margin-top: 12px; line-height: 1.5; }

      /* game */
      .game { padding-top: 16px; }
      .topbar { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 32px; }
      .topbar .pill[data-alive="0"] { border-color: var(--danger); color: var(--danger); text-decoration: line-through; }
      .top-action { margin-left: auto; }

      /* role reveal — every role shows in the same green so a role can't be read from the screen */
      .reveal { display: flex; flex-direction: column; align-items: center; gap: 20px; padding-top: 40px; text-align: center; }
      .reveal-role { font-family: 'Oswald'; font-weight: 600; font-size: 120px; line-height: 1; letter-spacing: -.02em; color: var(--accent); }
      .reveal-role.town { color: var(--accent); }
      .reveal-desc { max-width: 420px; color: var(--ink-dim); font-size: 17px; line-height: 1.5; }
      .reveal-team { font-family: 'JetBrains Mono'; font-size: 12px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); }
      .reveal-team-list { font-family: 'Oswald'; font-size: 24px; color: var(--ink); text-align: center; }
      .reveal-countdown { display: flex; flex-direction: column; align-items: center; gap: 6px; }
      .reveal-countdown .timer { font-size: 56px; }

      /* night */
      .night { display: flex; flex-direction: column; align-items: center; gap: 24px; padding-top: 80px; text-align: center; }
      .night h1 { font-family: 'Oswald'; font-weight: 600; font-size: 64px; line-height: 1; margin: 0; letter-spacing: -.01em; }
      .night .moon { width: 84px; height: 84px; border-radius: 50%; background: radial-gradient(circle at 35% 35%, var(--bg3), var(--bg)); border: 1px solid var(--line-strong); }
      .night p { color: var(--ink-dim); font-size: 17px; max-width: 360px; line-height: 1.5; }

      /* target select */
      .action { display: flex; flex-direction: column; gap: 20px; }
      .action-head { display: flex; flex-direction: column; gap: 6px; }
      .action-head h1 { font-family: 'Oswald'; font-weight: 600; font-size: 48px; line-height: 1; margin: 0; letter-spacing: -.01em; }
      .action-head p { color: var(--ink-dim); font-size: 15px; margin: 0; }
      .targets { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
      .target { display: flex; justify-content: space-between; align-items: center; background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 18px 20px; cursor: pointer; color: var(--ink); transition: background .15s, border-color .15s, transform .1s var(--ease); }
      .target:hover { background: var(--bg3); border-color: var(--line-strong); }
      .target.sel { border-color: var(--accent); background: color-mix(in srgb, var(--accent) 10%, var(--bg2)); }
      .target.danger.sel { border-color: var(--danger); }
      .target .tn { font-family: 'Oswald'; font-weight: 600; font-size: 26px; letter-spacing: -.005em; }
      .target .tk { font-family: 'JetBrains Mono'; font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); }
      .mafia-confirm { display: grid; gap: 10px; max-width: 520px; }
      .mafia-confirm .confirm-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
      .mafia-confirm .confirm-meta { color: var(--ink-dim); font-size: 13px; line-height: 1.45; margin: 0; }
      .teammates { font-size: 14px; color: var(--ink-dim); }

      /* detective result */
      .detective-result { display: flex; flex-direction: column; align-items: center; gap: 20px; text-align: center; padding-top: 60px; }
      .detective-result .big { font-family: 'Oswald'; font-weight: 600; font-size: 80px; line-height: 1; letter-spacing: -.01em; }
      .detective-result .big.mafia { color: var(--danger); }
      .detective-result .big.town { color: var(--accent); }

      /* day */
      .day { display: flex; flex-direction: column; gap: 20px; }
      .day h1 { font-family: 'Oswald'; font-weight: 600; font-size: 48px; line-height: 1; margin: 0; letter-spacing: -.01em; }
      .announce { font-size: 18px; color: var(--ink); }
      .announce .who { color: var(--danger); font-weight: 600; }
      .announce .none { color: var(--accent); }
      .speaker-turn { display: grid; grid-template-columns: 1fr auto; gap: 8px 18px; align-items: center; background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 18px 20px; }
      .speaker-turn h2 { grid-column: 1; font-family: 'Oswald'; font-size: 38px; line-height: 1; margin: 0; }
      .speaker-clock { grid-column: 2; grid-row: 1 / span 2; font-family: 'JetBrains Mono'; font-size: 34px; color: var(--accent); }
      .speaker-done { grid-column: 1 / -1; justify-self: stretch; margin-top: 6px; }
      .speaker-turn[data-you="1"] { border-color: currentColor; }
      .speaker-turn[data-state="warn"] .speaker-clock { color: #a15f00; }
      .speaker-turn[data-state="danger"] .speaker-clock { color: #ffefe8; }
      .day.speaker-live { min-height: calc(100vh - 180px); margin: -16px -24px -64px; padding: 42px 24px 64px; color: #04140a; background: #27f26b; box-shadow: 0 0 0 100vmax #27f26b; clip-path: inset(0 -100vmax); }
      .day.speaker-live.warn { color: #231600; background: #ffd33d; box-shadow: 0 0 0 100vmax #ffd33d; }
      .day.speaker-live.danger { color: #fff8f4; background: #ff3326; box-shadow: 0 0 0 100vmax #ff3326; animation: pulse-danger 0.55s ease-in-out infinite alternate; }
      .day.speaker-live .muted,
      .day.speaker-live .label,
      .day.speaker-live .announce,
      .day.speaker-live .announce .none,
      .day.speaker-live .announce .who { color: currentColor; }
      .day.speaker-live .speaker-turn { color: currentColor; background: color-mix(in srgb, white 24%, transparent); border-color: currentColor; }
      .day.speaker-live .speaker-clock { color: currentColor; }
      .day.speaker-live .target { color: currentColor; background: color-mix(in srgb, white 18%, transparent); border-color: color-mix(in srgb, currentColor 45%, transparent); }
      @keyframes pulse-danger { from { filter: saturate(1); } to { filter: saturate(1.2) brightness(1.05); } }

      /* voting */
      .vote-totals { display: flex; flex-direction: column; gap: 6px; margin-top: 8px; }
      .vote-row { display: grid; grid-template-columns: 1fr auto; gap: 10px; align-items: center; padding: 10px 0; border-bottom: 1px solid var(--line); }
      .vote-row .vn { font-family: 'Oswald'; font-weight: 500; font-size: 22px; }
      .vote-row .vc { font-family: 'JetBrains Mono'; font-size: 16px; color: var(--accent); }
      .vote-row .vv { grid-column: 1 / -1; margin-top: 2px; font-size: 13px; line-height: 1.35; color: var(--ink-dim); }
      .abstain.sel { border-color: var(--accent); color: var(--accent); }
      .timer[data-overtime="1"] { color: var(--danger); }

      /* tiebreak */
      .tie-candidates { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
      .tie-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
      .tie-actions .sel { outline: 2px solid var(--accent); }

      /* last words */
      .last-words { display: flex; flex-direction: column; gap: 16px; padding-top: 24px; }
      .last-words h1 { font-family: 'Oswald'; font-weight: 600; font-size: 48px; line-height: 1; margin: 0; letter-spacing: -.01em; }

      /* timer */
      .timer { font-family: 'JetBrains Mono'; font-size: 40px; color: var(--accent); letter-spacing: 0.05em; }
      .timer.warn { color: var(--danger); }

      /* dead */
      .dead-screen { display: flex; flex-direction: column; align-items: center; gap: 20px; padding-top: 80px; text-align: center; }
      .dead-screen h1 { font-family: 'Oswald'; font-weight: 600; font-size: 72px; margin: 0; color: var(--danger); }

      /* game over */
      .over { display: flex; flex-direction: column; align-items: center; gap: 24px; padding-top: 60px; text-align: center; }
      .over h1 { font-family: 'Oswald'; font-weight: 600; font-size: 96px; line-height: 1; margin: 0; letter-spacing: -.02em; }
      .over h1.mafia { color: var(--danger); }
      .over h1.town { color: var(--accent); }
      .over .sub { color: var(--ink-dim); font-size: 17px; }

      .btn-secondary { margin-top: 8px; }

      @media (max-width: 760px) {
        .lobby { grid-template-columns: 1fr; }
        .targets { grid-template-columns: 1fr; }
        .name-grid { grid-template-columns: 1fr; }
        .reveal-role, .over h1 { font-size: 72px; }
        .night h1, .action-head h1, .day h1 { font-size: 40px; }
      }
    `}</style>
  );
}
